<template>
  <div id="app">
    <Viewport>
      <router-view></router-view>
    </Viewport>
  </div>
</template>

<script>
import Viewport from './components/elements/viewport/Viewport'

export default {
  name: 'App',
  components: {
    Viewport,
  }
}
</script>

<style lang="scss">
  @import './stylesheet/_reset.scss';
  @import './stylesheet/_icons.scss';
  @import './stylesheet/_fonts.scss';

  body{
    color: $orange--shade-8;
    font-family: $open-sans, sans-serif;
    /* Disables pull-to-refresh but allows overscroll glow effects. */
    overscroll-behavior-y: contain;
  }

  @media (min-width: 768px) {
      body, html{
          overflow: hidden;
      }
  }
</style>
